import 'babel-polyfill';
import 'es5-shim';
import 'html5shiv';

import React from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { hydrate, render } from 'react-dom';

import App from './App';
import store, { history } from './redux/store';
import registerServiceWorker from './registerServiceWorker';

const appStructure = (
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>
);

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate(appStructure, rootElement);
} else {
  render(appStructure, rootElement);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js